export class Attempt {
    video_interview_id;
    status;
    student;
    created;
    modified;
    questions;
    video_interview;
    constructor(video_interview_id, status, student, created, modified, questions, video_interview) {
        this.video_interview_id = video_interview_id;
        this.status = status;
        this.student = student;
        this.created = created;
        this.modified = modified;
        this.questions = questions;
        this.video_interview = video_interview;
    }

    get status_display() {
        return this.status._label;
    }

    get display() {
        return this.video_interview.title;
    }

    get student_display() {
        return this.student._label;
    }
}
